
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--color-picker condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElColorPicker
        v-bind="contentProps"
        v-on="$listeners"
        :disabled="insetDisabled"
        :value="checked"
        class="condition-item__content"
        @change="change"
    ></ElColorPicker>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else>
            <component :is="getNode(postfix, checked)"></component>
        </template>
    </div>
</ElFormItem>
